 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-0b2da9dc":"abaff17b","chunk-2930791f":"64891a1e","chunk-29cc9e16":"1a85d6f7","chunk-2d0de6c5":"20c84243","chunk-2d22c521":"02b1433a","chunk-2d0ab4fa":"9514fda8","chunk-2d0ba54a":"addd5ebd","chunk-2d0baa7a":"4f7b62d5","chunk-2d0c0a08":"74447207","chunk-2d0c882a":"aa694faa","chunk-2d0c8d9c":"f1e07412","chunk-2d0c95b3":"3cf00cc0","chunk-2d0ceb62":"51da6d67","chunk-2d0df0a9":"21619f0b","chunk-2d0e66f2":"40c601ee","chunk-2d0e9b18":"360b7547","chunk-2d0f0471":"377116ee","chunk-2d0f064c":"c260ca05","chunk-2d215faa":"441e1ffd","chunk-2d216644":"50d3ce44","chunk-2d229bda":"bf84c3ba","chunk-2d237575":"c26be471","chunk-43ed476e":"adfdd800","chunk-5bae140a":"a496481e","chunk-632b4076":"2cd04264","chunk-730f0b11":"8d60f5e3","chunk-73101d88":"4eab1932","chunk-740eee44":"bcc4c135","chunk-582fb386":"13803d38","chunk-9833d2ce":"50d6f4e7","chunk-a544c2ca":"68a00f87","chunk-a8492f9c":"92d35887","chunk-d512b180":"5650d358","chunk-e474de86":"84c3d2cd","chunk-ef25784a":"bacbbb10","chunk-219c45ee":"4a340cb5","chunk-1c085e0c":"b29b02aa","chunk-2d0ccb75":"55f6fd02","chunk-36d50189":"de033c22","chunk-3837318e":"6b6715ac","chunk-0d7e16a7":"6e8adb1e","chunk-2d0c13a3":"7f46f991","chunk-4f911f00":"6ec94606","chunk-57200f15":"e312cf86","chunk-91165e1a":"3c58122f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0b2da9dc":1,"chunk-2930791f":1,"chunk-29cc9e16":1,"chunk-43ed476e":1,"chunk-5bae140a":1,"chunk-740eee44":1,"chunk-582fb386":1,"chunk-9833d2ce":1,"chunk-a544c2ca":1,"chunk-a8492f9c":1,"chunk-d512b180":1,"chunk-e474de86":1,"chunk-ef25784a":1,"chunk-219c45ee":1,"chunk-1c085e0c":1,"chunk-36d50189":1,"chunk-3837318e":1,"chunk-4f911f00":1,"chunk-57200f15":1,"chunk-91165e1a":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-0b2da9dc":"26499d03","chunk-2930791f":"c2b2e557","chunk-29cc9e16":"8c3b68be","chunk-2d0de6c5":"31d6cfe0","chunk-2d22c521":"31d6cfe0","chunk-2d0ab4fa":"31d6cfe0","chunk-2d0ba54a":"31d6cfe0","chunk-2d0baa7a":"31d6cfe0","chunk-2d0c0a08":"31d6cfe0","chunk-2d0c882a":"31d6cfe0","chunk-2d0c8d9c":"31d6cfe0","chunk-2d0c95b3":"31d6cfe0","chunk-2d0ceb62":"31d6cfe0","chunk-2d0df0a9":"31d6cfe0","chunk-2d0e66f2":"31d6cfe0","chunk-2d0e9b18":"31d6cfe0","chunk-2d0f0471":"31d6cfe0","chunk-2d0f064c":"31d6cfe0","chunk-2d215faa":"31d6cfe0","chunk-2d216644":"31d6cfe0","chunk-2d229bda":"31d6cfe0","chunk-2d237575":"31d6cfe0","chunk-43ed476e":"cab59e1c","chunk-5bae140a":"40406b2f","chunk-632b4076":"31d6cfe0","chunk-730f0b11":"31d6cfe0","chunk-73101d88":"31d6cfe0","chunk-740eee44":"ea3c4e9d","chunk-582fb386":"2090ba31","chunk-9833d2ce":"cab59e1c","chunk-a544c2ca":"cab59e1c","chunk-a8492f9c":"8dc5784a","chunk-d512b180":"86fd2b72","chunk-e474de86":"ab1ef08c","chunk-ef25784a":"ece4db0b","chunk-219c45ee":"0ffb3f69","chunk-1c085e0c":"f4ebb1c1","chunk-2d0ccb75":"31d6cfe0","chunk-36d50189":"49830f27","chunk-3837318e":"d253099c","chunk-0d7e16a7":"31d6cfe0","chunk-2d0c13a3":"31d6cfe0","chunk-4f911f00":"49830f27","chunk-57200f15":"49830f27","chunk-91165e1a":"0b94f07b"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/moodle-auth/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
